import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/

class SOA_P_Viewques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      questions: [],
      token: '',
      idname: '',
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1000,
      answered: [],
      answered_state: [],
      showFreePremium: true,
      subscription_details: '',
      chapters: [],
      subscription_details_for_isActive: '',
      chapter_video_redirect: '',
      selectedmenu: 'soa_p',
    };
  }
  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    window.scrollTo(0, 0);
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.id,
      chapter_id: this.props.params.chapter_no,
      offset: this.state.offset,
      limit: this.state.limit,
    };
    // console.log(data);
    await FD.callAPI(App_data.backend_api + '/soa_p_notes/getNotes', data).then(
      (resp) => {
        // console.log(resp);
        // console.log(resp.questions);
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({ questions: resp.questions });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      }
    );

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(
      async (resp) => {
        var exam_selected = resp.profileInfo.exam_selected
          ? JSON.parse(resp.profileInfo.exam_selected)
          : resp.profileInfo.exam_selected;
        var subscription_details = resp.profileInfo.subscription_details
          ? JSON.parse(resp.profileInfo.subscription_details)
          : resp.profileInfo.subscription_details;
        this.setState({ subscription_details: subscription_details });
      }
    );
  }

  _getReadings = () => {
    // console.log('working')
    this.context.router.push({
      pathname: `/soa/probability/notesreadings/${this.props.params.chapter_no
        }`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: this.props.location.state.reading.chapter_no,
      // },
    });
  };

  _beginNotes = (item, e) => {
    // console.log(item)
    this.context.router.push({
      pathname:
        '/soa/probability/beginnotes/' +
        item.chapter_id +
        '/' +
        item.reading_id +
        '/' +
        item.id,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: item.reading_id,
        chapter: item.chapter_id,
      },
    });
  };

  render() {
    // console.log('working')
    let questions = this.state.questions;
    let data = '';
    if (this.state.questions.length) {
      data = questions.map((item, index) => (
        <div className='col-md-6 col-lg-4' key={index}>
          <div
            onClick={this._beginNotes.bind(this, item)}
            className='border_box'
          >
            <div className='border_box_title'>
              <p>
                <img
                  src={App_data.frontend_url + '/img/notes/notes_icon4.svg'}
                  className='margin_right_20'
                  alt=''
                  width='21'
                />
                {/* {item.id}  */}
                {item.name}({language.LC().N} {item.id})
              </p>
            </div>

            <div className='padding_box cfa_notes_view'>
              {item.discription ? (
                renderHTMLContent(item.discription.substr(0, 550) + '...', "div", "view_question_height view_questionhtml margin_bottom_40", { contentEditable: "false" })
              ) : null}
              <UserInfo
                itemid={item.id}
                chapter_id={this.props.params.chapter_no}
                reading_id={this.props.params.id}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
              />
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }
    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.props.params.reading}</h1>
          </div>

          <div className='col-md-4 text-md-right margin_bottom_20'>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {' '}
              {language.LC().CHANGE_READING}{' '}
            </button>
          </div>
        </div>
        <div className='row'>{data}</div>
      </div>
    );
  }
}

function UserInfo(props) {
  // console.log('working')
  var data = {
    itemid: props.itemid,
    chapter_id: props.chapter_id,
    reading_id: props.reading_id,
    idname: props.idname,
    token: props.token,
  };
  FD.callAPI(App_data.backend_api + '/soa_p_notes/getNotesByuser', data).then(
    (resp) => {
      // console.log('working')
      if (resp.success) {
        if (resp.success === 'success') {
          document.getElementById(
            'user_question_status' + props.answered_state
          ).innerHTML = 'Read';
          document.getElementById(
            'user_question_status' + props.answered_state
          ).id = 'answered_status';
        } else {
          document.getElementById(
            'user_question_status' + props.answered_state
          ).innerHTML = 'Not Read';
          document.getElementById(
            'user_question_status' + props.answered_state
          ).id = 'notanswered_status';
        }
      } else {
        document.getElementById(
          'user_question_status' + props.answered_state
        ).innerHTML = resp.success;
      }
    }
  );
  return (
    <div>
      <div id={'user_question_status' + props.answered_state} />
    </div>
  );
}

export default SOA_P_Viewques;

// function UserInfo(props) {
//     var data = { 'itemid': props.itemid, 'chapter_id': props.chapter_id, 'reading_id': props.reading_id, idname: props.idname, 'token': props.token };

//     FD.callAPI(App_data.backend_api + '/cfa_notes/getNotesByuser', data).then(resp => {
//         if (resp.success) {
//             if (resp.success == "success") {

//                 document.getElementById('user_question_status' + props.answered_state).innerHTML = "Read";
//                 document.getElementById('user_question_status' + props.answered_state).id = "answered_status";
//             }
//             else {
//                 document.getElementById('user_question_status' + props.answered_state).innerHTML = "Unread";
//                 document.getElementById('user_question_status' + props.answered_state).id = "notanswered_status";

//             }
//         }
//         else {
//             document.getElementById('user_question_status' + props.answered_state).innerHTML = resp.success;
//         }

//     })

//     return (<div><div id={'user_question_status' + props.answered_state} ></div></div>
//     );
// }



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/NotesViewques/NotesViewques.js